import React, { useState, useMemo, useEffect } from "react";
import Menu from "../../../../components/layout/menu/index";
import '../../../../../src/index.css'
import ListFilterBillingAdmin from "../../../../components/filters/billingAdminFilters";
import ResetFilters from "../../../../components/filters/resetFilters";
import DownloadDocumentButton from "../../../../components/shared/downloadDocument"
import DynamicTable from "../../../../components/tables/oc/provider/dynamicTable";
import { getListFacturation, downloadFacturationExcel } from "../../../../client/facturation/index"
import { UpdatePdfOC } from "../../../../client/purchaseOrder";
import PdfViewerModal from "../../../../components/pdfViewer";
import ModalAlertWarning from "../../../../components/shared/modals/modalAlertWarning";
const statusColors = {
    'Nota de crédito': '#E44949',
    'Pendiente de facturación': '#FFB81C',
    'Facturado': '#00A3E0',
    'Observado': '#E44949'
};

const statusMapping = {
    'Pend. facturación': 'Pendiente de facturación',
    'Pend. nota de crédito': 'Nota de crédito',
    'Facturado': 'Facturado',
    'Observado': 'Observado'
};

const formatDecimal = (value) => {
  if (value === null || value === undefined) return '';
  const num = parseFloat(value);
  if (isNaN(num)) return '';
      
  return num.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
};

<style>
{`
.table-simplebar .simplebar-scrollbar {
background: #007696;
border-radius: 20px;
width: 5px;
}

.table-simplebar .simplebar-scrollbar:before {
background: #007696 !important;
}
`}
</style>


export default function BillingAdmin() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState('');

  const [allData, setAllData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  const [resetFlag, setResetFlag] = useState(false);

  const [pdfUrl, setPdfUrl] = useState(null);
  const [showPdfModal, setShowPdfModal] = useState(false);
const [showAlertWarning, setShowAlertWarning] = useState(false);
const [alertMessage, setAlertMessage] = useState('');

  const [activeFilters, setActiveFilters] = useState({
    statusIds: [],
    emissionDateFrom: '', 
    emissionDateTo: ''   
  });

  const [tempFilters, setTempFilters] = useState({
    statusIds: [],
    emissionDateFrom: '',
    emissionDateTo: ''
  });

  const [downloading, setDownloading] = useState(false);
  const [downloadProgress, setDownloadProgress] = useState('');

  useEffect(() => {
    fetchData();
  }, []);
  
  const transformApiData = (apiData) => {
    return apiData.map((item, index) => {
      return {
        index: index + 1 + ((currentPage - 1) * recordsPerPage),
        id: item.id,
        numeroOC: item.purchaseOrder.order_number,
        pos: item.position.number,
        pedido: item.purchaseOrderPosition.description,
        cant: item.purchaseOrderPosition.cant,
        un: item.purchaseOrderPosition?.unit_weight,
        estado: statusMapping[item.status.name] || item.status.name,
        fechaEmisión: item.purchaseOrder.emission_date,
        fechaEntrega: item.purchaseOrderPosition.delivery_Date,
        precio: formatDecimal(item.purchaseOrderPosition.price_per_unit),
        montoOC: formatDecimal(item.purchaseOrderPosition.em_dollarized),
        montoFacturado: formatDecimal(item.purchaseOrderPosition.fact_dollarized),
        detalles: () => handleViewDetails(item.purchaseOrder.id),
        rawData: item 
      };
    });
  };



const handleViewDetails = async (purchaseOrderId) => {
  try {
    const response = await UpdatePdfOC(purchaseOrderId);
    
    if (response.data.pdfUrl) {
      setPdfUrl(response.data.pdfUrl);
      setShowPdfModal(true);
    } else if (response.data.message === "La orden de compra ya tiene un PDF asociado.") {
      setPdfUrl(response.data.pdfUrl);
      setShowPdfModal(true);
    } else {
      setAlertMessage(response.data.message || "No se pudo obtener el PDF.");
      setShowAlertWarning(true);
    }
  } catch (error) {
    console.error("Error al actualizar el PDF:", error);
    
    const backendMessage = error.response?.data?.message;
    
    if (backendMessage) {
      setAlertMessage(backendMessage);
    } else {
      setAlertMessage("Error al cargar el PDF. Por favor intente nuevamente.");
    }
    
    setShowAlertWarning(true);
  }
};


  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await getListFacturation(
        activeFilters,
        searchTerm,
        currentPage,
        recordsPerPage
      );

      if (response.data && response.data.data) {
        const transformedData = transformApiData(response.data.data);
          setAllData(transformedData);
          setTotalRecords(response.data.totalCount);
          setTotalPages(response.data.totalPages);
      }
    } catch (err) {
      setError('Error al cargar los datos');
      console.error('Error fetching data:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [currentPage, recordsPerPage, activeFilters, searchTerm]);

  const tableConfig = {
    headers: [
      "#",
      "Número OC",
      "POS",
      "Pedido",
      "Cant.",
      "Un.",
      "Estado",
      "Fecha de emisión",
      "Fecha de entrega",
      "Precio",
      "Monto de entrada de mercancia (USD)",
      "Monto facturado (USD)",
      "Ver detalle completo"
    ],
    accessors: [
      "index",
      "numeroOC",
      "pos",
      "pedido",
      "cant",
      "un",
      "estado",
      "fechaEmisión",
      "fechaEntrega",
      "precio",
      "montoOC",
      "montoFacturado",
      "detalles"
    ],
    widths: [
      "46px", //#
      "111px", //Número OC
      "111px", // pos
      "246px", //pedido
      "111px", // cant
      "111px", // un
      "115px", // estado
      "111px", // fecha emision
      "112px", //fecha entrega
      "112px", // precio
      "112px", // monto oc
      "112px", // monto facturado
      "127px" // detalle
    ]
  };

  const applyFilters = (filters) => {
    setActiveFilters(filters);
    setCurrentPage(1);
  };

  const handleResetFilters = () => {
    const resetFilters = {
      statusIds: [],
      emissionDateFrom: '', 
      emissionDateTo: '' 
    };
    setActiveFilters(resetFilters);
    setTempFilters(resetFilters);
    setSearchTerm('');
    setResetFlag(prev => !prev);
    setCurrentPage(1);
  };

const handleDownloadExcel = async () => {
  setDownloading(true);
  setDownloadProgress('Preparando archivo...');
  
  try {
    setDownloadProgress('Generando datos...');
    
    const { emissionDateFrom, emissionDateTo } = activeFilters;
    
    const response = await downloadFacturationExcel(emissionDateFrom, emissionDateTo);
    
    const blob = new Blob([response.data], { 
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
    });
    
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    
    const contentDisposition = response.headers['content-disposition'];
    let fileName = `Facturaciones_${new Date().toISOString().slice(0, 10).replace(/-/g, '')}.xlsx`;
    
    if (contentDisposition) {
      const fileNameMatch = contentDisposition.match(/filename\*?=["']?(?:UTF-8'')?([^;"']+)["']?/i);
      if (fileNameMatch && fileNameMatch.length > 1) {
        fileName = decodeURIComponent(fileNameMatch[1]);
        
        fileName = fileName.replace(/^UTF-8''/, '').replace(/['"]/g, '');
        
        if (!fileName.endsWith('.xlsx')) {
          fileName += '.xlsx';
        }
      }
    }
    
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    
    setDownloadProgress('Descarga completada');
    
    setTimeout(() => {
      setDownloading(false);
      setDownloadProgress('');
    }, 1000);
    
  } catch (error) {
    console.error('Error en descarga:', error);
    setDownloadProgress('Error en la descarga');
    
    setTimeout(() => {
      setDownloading(false);
      setDownloadProgress('');
    }, 2000);
  }
};

  const handleRecordsCountChange = (e) => {
    const newRecordsPerPage = parseInt(e.target.value);
    setRecordsPerPage(newRecordsPerPage);
    setCurrentPage(1); 
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  return (
    <div>
      <Menu isMenuOpen={isMenuOpen} toggleMenu={toggleMenu} className="transition-all duration-300" />
      <div className={`flex-1 pt-[67px] transition-all duration-300 ${isMenuOpen ? "xl:pl-[20.7%] lg:pl-[23.7%] pl-0" : "pl-0"}  bg-[#F7F8F9] w-full z-50 min-h-screen`}>
      
      {/* Modal de PDF */}
      {showPdfModal && (
        <PdfViewerModal 
          pdfFile={pdfUrl} 
          onClose={() => {
            setShowPdfModal(false);
            setPdfUrl(null);
          }} 
        />
      )}
      {downloading && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[100]">
          <div className="max-w-md p-6 mx-4 bg-white rounded-lg">
            <div className="flex items-center justify-center mb-4">
              <div className="w-12 h-12 border-b-2 rounded-full animate-spin border-blue"></div>
            </div>
            <p className="mb-2 text-center text-gray-700 font-itcmedium">
              Descargando archivo...
            </p>
            <p className="text-sm text-center text-gray-600 font-itcbook">
              {downloadProgress}
            </p>
            <p className="mt-3 text-xs text-center text-gray-500 font-itcbook">
              Por favor espere, este proceso puede tomar varios segundos.
            </p>
          </div>
        </div>
      )}
       
        <div className="md:pt-8 pt-4 pb-10 px-[3%]">
          <div className="flex flex-col justify-between w-full gap-4">
            <div className="flex flex-col items-center justify-between gap-2 md:flex-row">
              <h1 className="text-2xl md:text-[32px] text-blue font-itcbold">
                Facturación
              </h1>
              <div className="flex flex-col items-center gap-6 md:flex-row">
                
                <div className="flex items-center">
                  <DownloadDocumentButton
                    text="Descargar"
                    onClick={handleDownloadExcel}
                    loading={downloading}
                    hasData={allData.length > 0}
                  />
                </div>
                
                <div className="flex flex-row items-center gap-6 ">
                    <ListFilterBillingAdmin
                    titleOption="Filtrar"
                    applyFilters={applyFilters}
                    resetFlag={resetFlag}
                    activeFilters={activeFilters}
                    />
                    <ResetFilters
                      borderColor="border-blue-light"
                      textColor="text-[#6B7280]"
                      font="font-itcbook"
                      onClick={handleResetFilters}
                    />
                </div>
              </div>
            </div>
            <div className="flex flex-col-reverse items-start justify-between gap-2 sm:items-center sm:flex-row">
              <div className="flex items-center space-x-2 text-sm font-itcbook">
                <p >Mostrar</p>
                <div className="border-[#D1D5DB] border-[1px] rounded-md w-[58px] flex justify-center items-center h-[40px]">
                  <select
                    className="w-full h-full px-2 text-sm bg-white rounded-md outline-none cursor-pointer font-itcbook"
                    value={recordsPerPage}
                    onChange={handleRecordsCountChange}  
                  >
                    <option value={10}>10</option>
                    <option value={15}>15</option>
                    <option value={25}>25</option>
                    <option value={50}>50</option>
                  </select>
                </div>
                <p >Registros</p>
              </div>

            </div>
            <DynamicTable
              data={allData}
              config={tableConfig}
              statusColors={statusColors}
              currentPage={currentPage}
              totalPages={totalPages}
              recordsPerPage={recordsPerPage}
              totalRecords={totalRecords}
              changePage={handlePageChange}
              loading={loading}
            />
          </div>
        </div>

      <ModalAlertWarning
        showModalAlertWarning={showAlertWarning}
        closeModal={() => setShowAlertWarning(false)}
        error={alertMessage}
        accept={() => setShowAlertWarning(false)}
      />
      </div>
    </div>
  );
}